let header = {
    init() {
        if(window.screenSize > 1279){

            window.onscroll = function(e) {
                // print "false" if direction is down and "true" if up
                //console.log(this.oldScroll > this.scrollY);

                if(this.oldScroll > this.scrollY == false && this.scrollY > 1){
                    $('.header').slideUp(300);
                    $('.header').removeClass('active');
                    $('.page-product .top').addClass('sticky');
                    $('.page-pack .top').addClass('sticky');
                }else{
                    $('.header').slideDown(300);
                    $('.header').addClass('active');
                    $('.page-product .top').removeClass('sticky');
                    $('.page-pack .top').removeClass('sticky');
                }
                this.oldScroll = this.scrollY;
            }
        }
    },
    search() {
        $('.header .btn-search').click(function(){
            $('.search-header').fadeIn(300);
        })

        $('.search-header .close').click(function(){
            $('.search-header').fadeOut(300);
        })
    }
}

export default header;
